document.addEventListener("DOMContentLoaded", () => {
  const obsCallback = function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const btn = document.querySelector(".show-more-cta");
        btn.click();
      }
    });
  };

  const obsOptions = {
    root: null,
    threshold: 0.1,
  };

  setTimeout(() => {
    const btn = document.querySelector(".show-more-cta");
    const btnObserver = new IntersectionObserver(obsCallback, obsOptions);
    btnObserver.observe(btn);
  }, 3000);
});
